import { ImageViewerImage } from "@omni/types/api/product/bff/shared/imageViewerImage.model";
import { ImageViewerVideo } from "@omni/types/api/product/bff/shared/imageViewerVideo.model";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as ImageViewerModule from "@/redux/modules/value/imageViewer/imageViewer.module";
import * as ImageViewerSelectors from "@/redux/modules/value/imageViewer/imageViewer.selectors";

import { ImageViewer } from "./imageViewer.component";

export type ImageViewerContainerProps = {
    title?: string;
    images: Array<ImageViewerImage>;
    videos: Array<ImageViewerVideo>;
    usesdefaultimage?: string;
    defaultVideoThumbnailPath?: string;
    ecoChequesAccepted: boolean;
};

const ImageViewerContainer = ({
    title,
    images,
    videos,
    usesdefaultimage,
    defaultVideoThumbnailPath,
    ecoChequesAccepted
}: ImageViewerContainerProps) => {
    const activeIndex = useSelector(ImageViewerSelectors.getActiveIndex);
    const dispatch = useThunkDispatch();
    const setActiveIndex = (index: number) => {
        dispatch(ImageViewerModule.update({ activeIndex: index }));
    };

    return (
        <ImageViewer
            title={title}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            images={images || []}
            videos={videos || []}
            usesDefaultImage={usesdefaultimage === "1"}
            defaultVideoThumbnailPath={defaultVideoThumbnailPath}
            ecoChequesAccepted={ecoChequesAccepted}
        />
    );
};

export { ImageViewerContainer };
